module.exports = __webpack_public_path__ + "static/media/upload_error.856b0984.svg";